/* World of ASVA — homepage motion.
   No dependencies. One shared IntersectionObserver for the whole page;
   elements unobserve after revealing so nothing runs on scroll. */
(function () {
  'use strict';

  function init() {
    var nodes = document.querySelectorAll('.asva [data-asva-reveal]:not(.is-revealed)');
    if (!nodes.length) return;

    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-revealed');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-asva-reveal'), 10) || 0;
          setTimeout(function () {
            el.classList.add('is-revealed');
          }, delay);
          observer.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    for (var j = 0; j < nodes.length; j++) observer.observe(nodes[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
